import React, { Fragment, useState } from "react";
import { Card, CardBody, CardFooter, Col, Row } from "reactstrap";
import TransitionOnLoad from "Components/TransitionOnLoad";
import PageHeading from "Layout/AppMain/PageHeading";
import 'react-datepicker/dist/react-datepicker.css';
import 'tippy.js/dist/tippy.css';
import { ReactComponent as CrossIcon } from "../../../assets/utils/images/svgs/Cross.svg";
import { FaRegCheckCircle } from "react-icons/fa";
import { useLoginLogs, useRoles, usePlatforms } from 'Api/Common/LogboekLogin';
import ReactTableGeneric from 'Components/ReactTableGeneric';
import moment from 'moment';
import { DropdownList } from "react-widgets/cjs";
import Loader from 'react-loaders';

const LogboekLogin = () => {
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedPlatform, setSelectedPlatform] = useState(null);

    const {
        data: platformsResponse,
        isLoading: platformsLoading,
    } = usePlatforms();

    const platforms = [
        "Alle",
        ...(platformsResponse?.data || []),
    ];

    const {
        data: rolesResponse,
        isLoading: rolesLoading,
    } = useRoles();

    const roles = [
        { value: null, label: "Alle rollen" },
        ...((rolesResponse?.data || []).map(role => ({
            value: role,
            label: role.charAt(0).toUpperCase() + role.slice(1),
        }))),
    ];



    const {
        data: loginLogsResponse,
        isLoading,
        isValidating,
        mutate,
    } = useLoginLogs(
        selectedRole === "Alle" ? null : selectedRole,
        selectedPlatform === "Alle" ? null : selectedPlatform
    );

    const logs = loginLogsResponse?.data || [];
    const totalCount = loginLogsResponse?.totalCount || []

    const columns = [
        {
            header: 'Datum-tijd',
            accessorKey: 'datum_tijd',
            cell: ({ row }) =>
                moment(row.original.datum_tijd).format('DD-MM-YYYY HH:mm:ss')
        },
        {
            header: 'Clooser ID',
            accessorKey: 'clooser_id'
        },
        {
            header: 'Naam - Clooser-id',
            accessorKey: 'naam_clooser_id',
            cell: ({ row }) =>
                row.original.naam_clooser_id === ' - '
                    ? row.original.vUserName
                    : row.original.naam_clooser_id,

        },
        {
            header: 'Bestuur',
            accessorKey: 'bestuur',

        },
        {
            header: 'Rol',
            accessorKey: 'rol',
            cell: ({ getValue }) =>
                Array.isArray(getValue())
                    ? getValue().map(role => role.toUpperCase()).join(' / ')
                    : getValue()
        },
        {
            header: 'Type',
            accessorKey: 'type',
            cell: ({ row }) => {
                const type = row.original.type;
                const typeLabels = {
                    'login-failed': 'Inloggen mislukt',
                    'impersonate-failed': 'Impersonatie mislukt',
                    'non_existing_user': 'Niet-bestaand',
                };
                return (typeLabels[type] || type?.charAt(0).toUpperCase() + type?.slice(1).replace(/_/g, ' ') || '-');
            },
        },
        {
            header: 'Imporsonated',
            accessorKey: 'impersonated'
        },
        {
            header: "Resultaat",
            accessorKey: "resultaat",
            cell: ({ cell, row }) => {
                return ["login", "impersonate", "user"].includes(
                    String(cell.getValue()).toLowerCase().trim()
                ) ? (
                    <FaRegCheckCircle color="green" />
                ) : (
                    <CrossIcon color="red" />
                );
            },
        },

        {
            header: 'Platform',
            accessorKey: 'platform',
            enableSorting: false,

        },
        {
            Header: 'Ip-adres',
            accessorKey: 'ip_adres',
            enableSorting: false,

        },
        {
            header: 'Browser',
            accessorKey: 'browser'
        },
    ];

      if (isLoading || isValidating){
            return (
                <Loader
                    type="ball-grid-pulse"
                    className="mt-3 d-flex mx-auto justify-content-center"
                />
            );
        }

    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <Row>
                    <Col md="12">
                        <Card className="main-card mb-3">
                            <CardBody className="p-3">
                                <ReactTableGeneric
                                    data={logs}
                                    columns={columns}
                                    filters={{
                                        search: true,
                                        pagination: true,
                                        sorting: true,
                                    }}
                                    tableClassName="mb-0 table table-sm table-hover table-borderless color-white"
                                    count={totalCount}
                                />
                            </CardBody>

                        </Card>
                    </Col>
                </Row>
            </TransitionOnLoad>
            <div className="chat-layout-footer">
                <CardFooter className="chat-layout-footer__inner gebruikers-footer">
                    <div className="d-flex gap-3 mr-4">
                        <div className="footer-field-min-width d-flex flex-row gap-2 ">
                            <div style={{ width: '150px' }}>

                                <DropdownList
                                    data={roles}
                                    dataKey="value"
                                    textField="label"
                                    value={
                                        selectedRole === null
                                            ? roles[0]
                                            : roles.find(r => r.value === selectedRole)
                                    }
                                    onChange={(item) =>
                                        setSelectedRole(item?.value === "Alle" ? null : item?.value)
                                    }
                                    placeholder="Alle rollen"
                                    filter="contains"
                                    dropUp
                                />
                            </div>
                            <div style={{ width: '150px' }}>

                                <DropdownList
                                    data={platforms}
                                    value={selectedPlatform}
                                    onChange={setSelectedPlatform}
                                    placeholder="Alle platforms"
                                    filter="contains"
                                    dropUp
                                />
                            </div>
                        </div>
                    </div>
                </CardFooter>
            </div>
        </Fragment>
    )
}

export default LogboekLogin;
